export default __webpack_public_path__ + "static/media/offerblue.68c2cf22.svg";